import getNodeName from "./getNodeName.js";
export default function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/@popperjs/core/lib/dom-utils/isTableElement.js
// module id = 974
// module chunks = 3